module.exports = __webpack_public_path__ + "static/media/video_play_icon_16_20.519b590b.svg";